import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Grid,
  Snackbar,
} from "@material-ui/core";
import MainInfo from "./MainInfo";
import mainStyles from "../WorkerManagementComponent/WorkerManagementComponent.module.css";
import styles from "../AgentSkillsManagement/styles.module.css";
import ConfirmComponent from "../ConfirmComponent/ConfirmComponent";
import { Alert } from "@material-ui/lab";
import { DeleteForever } from "@material-ui/icons";
import { GreenBtn } from "../Styled/StyledButtons";
import { useEffect, useState } from "react";
import { Department } from "../../models";
import { ICustomSkill } from "../../models/AgentSkills/CustomSkill";
import { IExternalAgent, ITaskChannel } from "./IExternalAgent";
import { TeamsActions } from "../../actions/TeamsActions";
import TaskChannels from "./TaskChannels";
import Departments from "./Departments";
import { DepartmentsActions } from "../../services/departments.actions";
import { AgentSkillsActions } from "../../actions/AgentSkillsActions";
import CustomSkills from "./CustomSkills";
import Activities from "./Activities";
import KPIs from "./KPIs";
import { ExternalAgentsActions } from "../../actions/ExternalAgentsActions";

const ExternalAgent = () => {
  const [externalAgent, setExternalAgent] = useState<IExternalAgent>(
    {} as IExternalAgent
  );
  const [teams, setTeams] = useState<Array<{ Id: number; Name: string }>>([]);
  const [departments, setDepartments] = useState<Array<Department>>([]);
  const [customSkills, setCustomSkills] = useState<Array<ICustomSkill>>([]);
  const [taskChannels, setTaskChannels] = useState<Array<ITaskChannel>>([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errors, setErrors] = useState<string>("");
  const [saving, setSaving] = useState(false);
  const [backdrop, setBackdrop] = useState(false);
  const [discardConfirmShow, setDiscardConfirmShow] = useState(false);
  const [deleteConfirmShow, setDeleteConfirmShow] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setBackdrop(true);
      await TeamsActions.getTeams().then(teams => {
        setTeams(teams);
      });
      await DepartmentsActions.get().then(dep =>
        setDepartments(dep)
      );
      await AgentSkillsActions.getSkills()
            .then(skills => setCustomSkills(skills as unknown as ICustomSkill[]));
      setBackdrop(false);
    };
    
    fetchData();
  }, []);

  const handleTeam = (teamId: string) => {
    setExternalAgent({

      ...externalAgent,
      team_id: teamId === "null" ? undefined : parseInt(teamId),
    });
  };

  function departmentsChangeHandle(updatedDepartments: number[]): void {
    setExternalAgent({
      ...externalAgent,
      departments: updatedDepartments,
    });
  }

  function customSkillsChangeHandle(id: number, value: string): void {
    const updatedSkills = externalAgent.skills ? [...externalAgent.skills] : [];
    const skillIndex = updatedSkills.findIndex((s) => s.id === id);
    if (skillIndex !== -1) {
      updatedSkills[skillIndex].value = value;
    } else {
      updatedSkills.push({ id: id, value: value });
    }
    setExternalAgent({
      ...externalAgent,
      skills: updatedSkills,
    });
  }
  function closeDeleteConfirm(): void {
    setDeleteConfirmShow(false);
  }

  function deleteAgent(): void {
    throw new Error("Function not implemented.");
  }

  function updateAgent(): void {
    if(externalAgent.id){
      ExternalAgentsActions.update(externalAgent.id, externalAgent)
        .then(() => {
          setAlert(true);
        })
        .catch((error) => {
          setErrors(error.toString());
          setErrorAlert(true);
        })
        .finally(() => {
          setSaving(false);
        });
    } else {
      ExternalAgentsActions.create(externalAgent)
        .then(() => {
          setAlert(true);
        })
        .catch((error) => {
          setErrors(error.toString());
          setErrorAlert(true);
        })
        .finally(() => {
          setSaving(false);
        });
    }
  }

  const handleClose = () => {
    setAlert(false);
  };

  const handleCloseError = () => {
    setErrorAlert(false);
  };

  const handleBool = (name: string, checked: boolean) => {
    setExternalAgent({
      ...externalAgent,
      [name]: checked,
    });
  };

  const handleChangeAgent = (updatedAgent: IExternalAgent) => {
    setExternalAgent(updatedAgent);
  }

  return (
    <>
      <Container maxWidth={false}>
        <Grid container spacing={1}>
          <Grid item xs={12} className={mainStyles.WorkerSkillsBack}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={6}>
                <div className={mainStyles.Header}>
                  {externalAgent.id
                    ? "Edit External Agent"
                    : "Add External Agent"}
                </div>
                <div className={mainStyles.AgentName}>
                  {" "}
                  {externalAgent.name || "New External Agent"}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={styles.ButtonMargin}>
                  <label className={styles.FormLabel}>Agent Team</label>
                  <select
                    className={`${styles.FormControl}  ${styles.FullWidth}`}
                    value={externalAgent.team_id || "null"}
                    onChange={(event) => handleTeam(event.target.value)}
                  >
                    <option key={-1} value="null">
                      No Team
                    </option>
                    {teams.map((row) => (
                      <option key={row.Id} value={row.Id}>
                        {row.Name}
                      </option>
                    ))}
                  </select>
                </div>
              </Grid>

              <Grid item xs={12} md={4}>
                <MainInfo agent={externalAgent} onChange={handleChangeAgent}/>
                <Departments
                  departments={departments}
                  agentDepartments={externalAgent.departments || []}
                  onChange={departmentsChangeHandle}
                />
              </Grid>
              <Grid item xs={12} md={4} className={`${styles.FullHeight}`}>
                <Activities
                  agent={externalAgent}
                  handleChange={handleBool}
                />
                <CustomSkills
                  customSkills={customSkills}
                  agentSkills={externalAgent.skills || []}
                  onChange={customSkillsChangeHandle}
                  onRemove={(id: number) => {
                    const updatedSkills = (
                      externalAgent.skills || []
                    ).filter((s) => s.id !== id);
                    setExternalAgent({
                      ...externalAgent,
                      skills: updatedSkills,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <KPIs agent={externalAgent} handleChange={handleBool}/>
                {taskChannels.length>0 ? (
                  <TaskChannels
                    taskChannels={taskChannels}
                    onChange={(updatedChannels) => {
                      setTaskChannels(updatedChannels);
                    }}
                  />
                ) : null}
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
               
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  className={`${externalAgent.id ? styles.DisplayNone : ""}`}
                  color="secondary"
                  onClick={() => {
                    setDeleteConfirmShow(true);
                  }}
                >
                  <DeleteForever /> Delete Agent
                </Button>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={styles.ButtonMargin}>
                  <GreenBtn
                    disabled={saving}
                    className={mainStyles.floatRight}
                    onClick={updateAgent.bind(this)}
                    fullWidth={true}
                    variant="contained"
                    color="primary"
                  >
                    <CircularProgress
                      className={` ${styles.SaveProgress} ${
                        saving ? "" : styles.DisplayNone
                      }`}
                    />
                    &nbsp;&nbsp;Apply
                  </GreenBtn>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <ConfirmComponent
        show={discardConfirmShow}
        title="Discard changes"
        bodyText="Are you sure you want to discard unsaved changes?"
        close={() => setDiscardConfirmShow(false)}
        confirm={() => setDiscardConfirmShow(false)}
      ></ConfirmComponent>
      <Snackbar
        open={alert}
        autoHideDuration={5000}
        onClose={() => handleClose()}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={() => handleClose()}
          severity="success"
          variant="filled"
        >
          Saved!
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorAlert}
        autoHideDuration={5000}
        onClose={() => handleCloseError()}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={() => handleCloseError()}
          severity="error"
          variant="filled"
        >
          Error
          <br />
          <div className={styles.AlertError}>{errors}</div>
        </Alert>
      </Snackbar>
      <Backdrop className={styles.Backdrop} open={backdrop}>
        <CircularProgress className={styles.BackdropProgress} />
        &nbsp;&nbsp;
        <p className={styles.BackdropProgress}>Loading...</p>
      </Backdrop>
      <ConfirmComponent
        show={deleteConfirmShow}
        title={"Delete Agent " + (externalAgent.name || "")}
        bodyText="Are you sure you want to delete agent?"
        close={() => closeDeleteConfirm()}
        confirm={() => deleteAgent()}
      ></ConfirmComponent>
    </>
  );
};

export default ExternalAgent;
